module.exports = __webpack_public_path__ + "images/bug_green_large_7c9b22e3f3cf396038facf477782ea18.png";